import { Divider, Typography } from "antd";
import { Link, useLocation } from "react-router-dom";
import { CheckCircleOutlined } from "@ant-design/icons";
import DocUpdateIcon from "../../assets/DocUpdateIcon.svg";
import HipaaSealImage from "../../components/HipaaSeal/HipaaSeal";
import "./FormUnavailable.css";

const FormUnavailable = () => {
  const location = useLocation();
  const reason = location.state?.reason || "unavailable";
  const requestNumber = location.state?.requestNumber;

  // Determine content based on reason
  const isSuccess = reason === "success";
  const title = isSuccess ? "Request Submitted" : "Sample Request Form";
  const message = isSuccess
    ? `Your sample request${requestNumber ? ` (#SIMP${requestNumber})` : ""} has been submitted successfully.`
    : "This form has expired or is no longer available.";

  return (
    <div className="form-unavailable-container">
      {/* Header */}
      <header className="form-unavailable-header">
        <Link to="https://www.docupdate.io/">
          <img
            src={DocUpdateIcon}
            alt="DocUpdate"
            className="form-unavailable-logo"
          />
        </Link>
      </header>

      {/* Main Content */}
      <main className="form-unavailable-main">
        <Typography.Title className="form-unavailable-title">
          {title}
        </Typography.Title>

        <div className="form-unavailable-message">
          <div className="form-unavailable-icon">
            {isSuccess ? (
              <div className="icon-square icon-success">
                <div className="icon-circle icon-circle-success">
                  <CheckCircleOutlined style={{ color: "white", fontSize: 16 }} />
                </div>
              </div>
            ) : (
              <div className="icon-square">
                <div className="icon-circle">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 8V12M12 16H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            )}
          </div>
          <Typography.Text className="form-unavailable-text">
            {message}
          </Typography.Text>
          {isSuccess && (
            <Typography.Text className="form-unavailable-subtext">
              You will receive a confirmation via SMS shortly.
            </Typography.Text>
          )}
        </div>
      </main>

      {/* Footer */}
      <footer className="form-unavailable-footer">
        <div className="form-unavailable-footer-top">
          <div className="form-unavailable-footer-left">
            <Link to="https://www.docupdate.io/">
              <img
                src={DocUpdateIcon}
                alt="DocUpdate"
                className="form-unavailable-footer-logo"
              />
            </Link>
            <nav className="form-unavailable-footer-nav">
              <Link
                to="https://www.docupdate.io/manage-preferences"
                className="form-unavailable-footer-link"
              >
                Manage Preferences
              </Link>
              <Link
                to="https://www.docupdate.io/#faq"
                className="form-unavailable-footer-link"
              >
                Help
              </Link>
              <Link
                to="https://www.docupdate.io/privacy-policy/"
                className="form-unavailable-footer-link"
              >
                Privacy Policy
              </Link>
            </nav>
          </div>
          <HipaaSealImage />
        </div>
        <Divider className="form-unavailable-footer-divider" />
        <div className="form-unavailable-footer-bottom">
          <Typography.Text className="form-unavailable-copyright">
            Copyright © 2025 DocUpdate | All Rights Reserved.
          </Typography.Text>
          <nav className="form-unavailable-footer-legal">
            <Link
              to="https://www.docupdate.io/terms-of-service/"
              className="form-unavailable-legal-link"
            >
              Terms of Service
            </Link>
            <Link
              to="https://www.docupdate.io/do-not-call-policy/"
              className="form-unavailable-legal-link"
            >
              DNC Policy
            </Link>
            <Link
              to="https://www.docupdate.io/hipaa-business-associate-agreement/"
              className="form-unavailable-legal-link"
            >
              HIPAA Terms
            </Link>
            <Link
              to="https://www.docupdate.io/ccpa-notice/"
              className="form-unavailable-legal-link"
            >
              CCPA Notice
            </Link>
          </nav>
        </div>
      </footer>
    </div>
  );
};

export default FormUnavailable;
